(ns hai.admin-ui.activities.routes
  (:require
   [hai.admin-ui.activities.table :as table]
   [hai.ui.icons :as icons]
   [hai.web-app.routing :as routing]))

(defn routes []
  [["/activities"
    {::routing/window-title "Activities"}
    [""
     {:name :admin-ui/activities
      :icon icons/outlined-psychology
      :label "Organizer"
      :view table/page}]]])
